module.exports = __webpack_public_path__ + "static/img/katun09.b291705.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/katun09.jpg
// module id = zx0q
// module chunks = 0